import React, { useEffect, useState, useContext, useRef } from 'react';
import { AppContext } from "../../util/AppContext";
import { getConfigValue } from "../../util/getConfigValue";
import { useErrorBoundary } from "react-error-boundary";
import { getUtilizationReportPdfGeneratedByTime } from '../../API/UtilizationReportingDashboard'
import PropType from 'prop-types';
import Tooltip from '../Tooltip';

TotalPdfsGeneratedCard.propTypes = {
    filters: PropType.object
};
function TotalPdfsGeneratedCard({ filters }) {
    const [appState] = useContext(AppContext);
    const [totalPdfGeneratedData, settotalPdfGeneratedData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const { showBoundary } = useErrorBoundary();
    const tootltipRefs = useRef({});
    const [tooltipState, setTooltipState] = useState({});
    const chartEnabled = JSON.parse(getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.Enabled, appState)?.Value === 'true') || true;
    const [keys, setKeys] = useState([]);

    function constructtotalPdfGeneratedData(pdfsGenerated) {
        function calculatetotalPdfGeneratedData(current, prior) {
            return (prior === 0 ? null : ((current - prior) / prior) * 100);
        }

        const noChangeSection = {
            tooltip: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.NoChange?.ToolTip, appState)?.Value || "This value is equivalent to the value from the previous time.",
            label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.NoChange?.Label, appState)?.Value || "N/A"
        };

        const data = {
            currentPeriod: {
                total: {
                    index: 0,
                    enabled: true,
                    label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsGenerated?.Label, appState)?.Value || "Generated",
                    count: pdfsGenerated.currentPeriod.dataSets[0].data[0],
                    NoPriorData: {
                        tooltip: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsGenerated?.NoPriorData?.ToolTip, appState)?.Value || "N/A because the previous time period had no PDFs generated.",
                        label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsGenerated?.NoPriorData?.Label, appState)?.Value || "*"
                    },
                    change: {
                        hasPriorData: pdfsGenerated.priorPeriod.dataSets[0].data[0] !== 0,
                        percent: calculatetotalPdfGeneratedData(pdfsGenerated.currentPeriod.dataSets[0].data[0], pdfsGenerated.priorPeriod.dataSets[0].data[0])
                    },
                    NoChange: noChangeSection
                },
                downloaded: {
                    index: 3,
                    enabled: getConfigValue(appState?.config?.Generate?.Document?.Download?.Enabled, appState)?.Value === 'true' || false,
                    label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsDownloaded?.Label, appState)?.Value || "Downloaded",
                    count: pdfsGenerated.currentPeriod.dataSets[0].data[1],
                    NoPriorData: {
                        tooltip: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsDownloaded?.NoPriorData?.ToolTip, appState)?.Value || "N/A because the previous time period had no PDFs downloaded.",
                        label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsDownloaded?.NoPriorData?.Label, appState)?.Value || "*"
                    },
                    change: {
                        hasPriorData: pdfsGenerated.priorPeriod.dataSets[0].data[1] !== 0,
                        percent: calculatetotalPdfGeneratedData(pdfsGenerated.currentPeriod.dataSets[0].data[1], pdfsGenerated.priorPeriod.dataSets[0].data[1])
                    },
                    NoChange: noChangeSection
                },
                printedLocal: {
                    index: 1,
                    enabled: getConfigValue(appState?.config?.Generate?.Document?.Print?.Enabled, appState)?.Value === 'true' || false,
                    label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsPrinted?.Label, appState)?.Value || "Printed Local",
                    count: pdfsGenerated.currentPeriod.dataSets[0].data[2],
                    NoPriorData: {
                        tooltip: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsPrinted?.NoPriorData?.ToolTip, appState)?.Value || "N/A because the previous time period had no PDFs printed locally.",
                        label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsPrinted?.NoPriorData?.Label, appState)?.Value || "*"
                    },
                    change: {
                        hasPriorData: pdfsGenerated.priorPeriod.dataSets[0].data[2] !== 0,
                        percent: calculatetotalPdfGeneratedData(pdfsGenerated.currentPeriod.dataSets[0].data[2], pdfsGenerated.priorPeriod.dataSets[0].data[2])
                    },
                    NoChange: noChangeSection
                },
                preview: {
                    index: 4,
                    enabled: true,
                    label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.Preview?.Label, appState)?.Value || "Preview",
                    count: pdfsGenerated.currentPeriod.dataSets[0].data[3],
                    NoPriorData: {
                        tooltip: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.Preview?.NoPriorData?.ToolTip, appState)?.Value || "N/A because the previous time period had no PDFs previewed.",
                        label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.Preview?.NoPriorData?.Label, appState)?.Value || "*"
                    },
                    change: {
                        hasPriorData: pdfsGenerated.priorPeriod.dataSets[0].data[3] !== 0,
                        percent: calculatetotalPdfGeneratedData(pdfsGenerated.currentPeriod.dataSets[0].data[3], pdfsGenerated.priorPeriod.dataSets[0].data[3])
                    },
                    NoChange: noChangeSection
                },
                printedPro: {
                    index: 2,
                    enabled: getConfigValue(appState?.config?.ProfessionalPrinting?.Enabled, appState)?.Value === 'true' || false,
                    label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsPrintedPro?.Label, appState)?.Value || "Printed Professionally",
                    count: pdfsGenerated.currentPeriod.dataSets[0].data[4],
                    NoPriorData: {
                        tooltip: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsPrintedPro?.NoPriorData?.ToolTip, appState)?.Value || "N/A because the previous time period had no PDFs printed professionally.",
                        label: getConfigValue(appState?.config?.UtilizationDashboard?.Charts?.TotalPdfsGeneratedCard?.TotalPdfsPrintedPro?.NoPriorData?.Label, appState)?.Value || "*"
                    },
                    change: {
                        hasPriorData: pdfsGenerated.priorPeriod.dataSets[0].data[4] !== 0,
                        percent: calculatetotalPdfGeneratedData(pdfsGenerated.currentPeriod.dataSets[0].data[4], pdfsGenerated.priorPeriod.dataSets[0].data[4])
                    },
                    NoChange: noChangeSection
                }
            }
        };

        const sortedFilteredKey = Object.keys(data.currentPeriod || {})
            .filter(key => data.currentPeriod[key]?.enabled)
            .sort((a, b) => {
                const indexA = data.currentPeriod[a].index ?? 0;
                const indexB = data.currentPeriod[b].index ?? 0;
                return indexA - indexB;
            });

        setKeys(sortedFilteredKey);

        return data;
    }


    const getTotalPdfGenerated = async (selectedTimePeriod) => {
        setIsLoading(true);

        await getUtilizationReportPdfGeneratedByTime(selectedTimePeriod)
            .then((responseJson) => {
                settotalPdfGeneratedData(constructtotalPdfGeneratedData(responseJson));
                setIsLoading(false);
            })
            .catch((err) => {
                showBoundary(err);
            });
    }


    useEffect(() => {
        if (chartEnabled && filters?.timePeriodId !== null) {
            getTotalPdfGenerated(filters.timePeriodId);
        }
    }, [filters.timePeriodId]);


    // UI Helpers    
    const setTotalPdfGeneratedClass = (percent, currentCount) => {
        if (percent === null || percent === 0) {
            return 'noPriorData';
        }
        return percent > 0 || (percent == null && currentCount > 0) ? 'positiveChange' : 'negativeChange';
    }
    const formatPercent = (percent) => {
        if (percent === null || percent === 0) {
            return '';
        }
        return percent.toFixed(1) + '%';
    }
    const formatTotalCount = (count) => {
        if (count > 1000) {
            return (count / 1000).toFixed(1) + 'K';
        }
        return count;
    }
    const setTotalCountChangeIcon = (percent, currentCount) => {
        if ((percent === null || percent === 0)) {
            return '';
        }

        return percent > 0 || (percent == null && currentCount > 0) ? "fas fa-caret-up" : "fas fa-caret-down";
    }

    const handleTooltipEvent = (key, show) => {
        setTooltipState(prev => ({ ...prev, [key]: show }));
    }

    const alignDivClass = (index) => {
        if (keys.length === 1) return 'justify-content-center';
        if (index === 0) return 'justify-content-end';
        if (index === keys.length - 1) return 'justify-content-start';
        return 'justify-content-center';
    }
    const alignLabelClass = (count) => {
        if (count > 4) return 'label-sm';
        if (count > 2) return 'label-md';
        return 'label';
    }
    const alignCountClass = (count) => {
        if (count > 4) return 'count-sm';
        if (count > 2) return 'count-md';
        return 'count';
    }

    const valueToolTipWidget = (key, label, tooltip) => {
        return (
            <>
                <button className='btn-ghost'
                    ref={tootltipRefs.current[key]}
                    onMouseEnter={() => handleTooltipEvent(key, true)}
                    onMouseLeave={() => handleTooltipEvent(key, false)}><span className='noPriorData'>{label}</span></button>
                <Tooltip
                    text={tooltip}
                    placement='right'
                    ref={tootltipRefs.current[key]}
                    showTooltip={tooltipState[key]} />
            </>
        )
    }

    return (
        <>
            {chartEnabled &&
                <div className="card pd-card pt-4 pt-md-4 pb-4 pb-md-6 chartCardContainer">
                    <div className="d-flex justify-content-between flex-wrap w-100">
                        {isLoading ? (
                            <div className="d-flex flex-fill align-items-center justify-content-center mx-2">
                                <p>{getConfigValue(appState.config.Common?.Loading, appState)?.Value}</p>
                            </div>
                        ) : keys.map((key, index) => {
                            if (!tootltipRefs.current[key]) {
                                tootltipRefs.current[key] = React.createRef();
                            }
                            const section = totalPdfGeneratedData.currentPeriod[key];
                            return (
                                <div
                                    key={key}
                                    className={`d-flex flex-fill align-items-center ${alignDivClass(index)} mx-2`}
                                >
                                    <span className={alignLabelClass(keys.length)}>{section.label}</span>
                                    <span className={alignCountClass(keys.length)}>{formatTotalCount(section.count)}</span>
                                    <div className={`d-flex align-items-center fw-bold ${setTotalPdfGeneratedClass(section.change.percent, section.count)}`}>
                                        <span className={setTotalCountChangeIcon(section.change.percent)}></span>
                                        {formatPercent(section.change.percent)}
                                        {!section.change.hasPriorData ? (
                                             valueToolTipWidget(key, section.NoPriorData.label, section.NoPriorData.tooltip)
                                        ) : (section.change.percent === 0 &&
                                            valueToolTipWidget(key, section.NoChange.label, section.NoChange.tooltip)
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            }
        </>
    );
}

export default TotalPdfsGeneratedCard;
